import { combineReducers } from 'redux';
import param from './param';
import programs from './programs';
import fetching from './fetching';
import last from './last';
import page from './page';
import size from './size';
import totalElements from './totalElements';
import totalPages from './totalPages';

export default combineReducers({
  param,
  programs,
  fetching,
  last,
  page,
  size,
  totalElements,
  totalPages,
});
